<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 310 300">
    <path
      fill="currentColor"
      d="M38 19l-19 19v225l19 18h225l18 -18v-225l-18 -19h-225zM38 244v-206h225v206h-225z"
    />
  </svg>
</template>
